import { ApiUserLimited } from './types/user'

export const getDisplayName = (user: ApiUserLimited) => user.firstName + ' ' + user.lastName
